<span class="detail-field__label">{{ label() }}</span>
<span class="detail-field__value" [class.detail-field__value--truncate]="truncate()">
  <ng-content />
</span>
